import "./styles.scss";

import { useTranslation } from "react-i18next";

import { scrollToTop } from "libs/helpers/ScrollToTop";

const mainClass = "scroll-top-mobile";

const ScrollTopMobile = ({ duration = 300, el = null }) => {
  const { t } = useTranslation();

  return (
    <div className={mainClass}>
      <button type="button" onClick={() => scrollToTop(duration, el?.current ?? el)}>
        {t("Back to top")}
      </button>
    </div>
  );
};

export default ScrollTopMobile;
